var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.show,"width":"30%","title":"分布图"},on:{"update:visible":function($event){_vm.show=$event}}},[_c('div',{staticClass:"re"},[_c('div',{ref:"map",staticClass:"map-wrap",style:({ height: _vm.height })})])])}
var staticRenderFns = []

export { render, staticRenderFns }